import { render, staticRenderFns } from "./registration-by-phone-confirmation.vue?vue&type=template&id=045c02e6"
import script from "./registration-by-phone-confirmation.vue?vue&type=script&lang=js"
export * from "./registration-by-phone-confirmation.vue?vue&type=script&lang=js"
import style0 from "./registration-by-phone-confirmation.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-phone-confirmation.vue
// module id = a/ro
// module chunks = 0